/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {
    background: { type: 'variant', values: [ true ] },
    color: {
      type: 'variant',
      values: [
        'brand',   'subtle',
        'offer',   'success',
        'danger',  'warning',
        'inverse'
      ]
    },
    padding: {
      type: 'variant',
      values: [ 'micro', 'small', 'medium', 'large', 'extraLarge' ]
    },
    size: {
      type: 'variant',
      values: [ 'micro', 'small', 'large', 'extraLarge' ]
    },
    status: {
      description: 'Uses icon colour to communicate meaning to the user',
      type: 'variant',
      values: [ 'success', 'error' ]
    }
  },
  rules: [
    { if: { padding: 'micro' }, tokens: { padding: 4, width: 4 } },
    { if: { padding: 'small' }, tokens: { padding: 4, width: 8 } },
    { if: { padding: 'medium' }, tokens: { padding: 4, width: 16 } },
    { if: { padding: 'large' }, tokens: { padding: 4, width: 24 } },
    {
      if: { padding: 'extraLarge' },
      tokens: { padding: 4, width: 32 }
    },
    {
      if: { background: true, padding: 'micro' },
      tokens: {
        backgroundColor: '#efefef',
        borderRadius: 45,
        padding: 4,
        width: 4
      }
    },
    {
      if: { background: true, padding: 'small' },
      tokens: {
        backgroundColor: '#efefef',
        borderRadius: 45,
        padding: 4,
        width: 8
      }
    },
    {
      if: { background: true, padding: 'medium' },
      tokens: {
        backgroundColor: '#efefef',
        borderRadius: 45,
        padding: 4,
        width: 16
      }
    },
    {
      if: { background: true, padding: 'large' },
      tokens: {
        backgroundColor: '#efefef',
        borderRadius: 45,
        padding: 4,
        width: 24
      }
    },
    {
      if: { background: true, padding: 'extraLarge' },
      tokens: {
        backgroundColor: '#efefef',
        borderRadius: 45,
        padding: 4,
        width: 32
      }
    },
    { if: { size: 'micro' }, tokens: { size: 16 } },
    { if: { size: 'small' }, tokens: { size: 20 } },
    { if: { size: 'large' }, tokens: { size: 32 } },
    { if: { size: 'extraLarge' }, tokens: { size: 48 } },
    { if: { color: 'brand' }, tokens: { color: '#ff0076' } },
    { if: { color: 'subtle' }, tokens: { color: '#666666' } },
    { if: { color: 'offer' }, tokens: { color: '#7a3dfc' } },
    { if: { color: 'success' }, tokens: { color: '#1c7b2b' } },
    { if: { color: 'danger' }, tokens: { color: '#c9370b' } },
    { if: { color: 'warning' }, tokens: { color: '#c9370b' } },
    { if: { color: 'inverse' }, tokens: { color: '#ffffff' } },
    { if: { status: 'success' }, tokens: { color: '#1c7b2b' } },
    { if: { status: 'error' }, tokens: { color: '#c9370b' } }
  ],
  tokens: {
    backgroundColor: 'transparent',
    borderRadius: 0,
    color: '#000000',
    gradient: null,
    padding: 0,
    paddingTop: 0,
    scale: 1,
    size: 24,
    translateX: 0,
    translateY: 0,
    width: 0
  }
}
export default theme
